import 'react-toastify/dist/ReactToastify.css';
import { PostHogAnalyticsProvider } from 'services/PostHoq/PostHoqAnalyticsProvider';
import AppRouting from './AppRouting';
import AppContextProvider from './AppContextProvider';

export interface IAppProps {}

const App = (props: IAppProps) => {
  //
  // Main render
  //
  return (
    <AppContextProvider>
      <PostHogAnalyticsProvider>
        <AppRouting></AppRouting>
      </PostHogAnalyticsProvider>
    </AppContextProvider>
  );
};

export default App;
